/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Action_ConflictInputs */

const cs_ebr_action_conflict = /** @type {(inputs: Ebr_Action_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konflikty`)
};

const en_ebr_action_conflict = /** @type {(inputs: Ebr_Action_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflicts`)
};

/**
* | output |
* | --- |
* | "Conflicts" |
*
* @param {Ebr_Action_ConflictInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_action_conflict = /** @type {((inputs?: Ebr_Action_ConflictInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Action_ConflictInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_action_conflict(inputs)
	return cs_ebr_action_conflict(inputs)
});